module.exports = __webpack_public_path__ + "static/media/Weather-Dashboard-screenshot.98296f82.png";